import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { I18nProvider } from "./contexts/I18nContext";
import { Toaster } from "./components/ui/sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="ortb-theme">
      <AuthProvider>
        <I18nProvider>
          <App />
          <Toaster position="top-right" richColors />
        </I18nProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
